import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNumNotifications,
  StateWithEmergencyCalls,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import Badge from '../Badge';

const EmergencyCallsBadge = () => {
  const dispatch = useDispatch();
  const { callQueue, numNotifications } = useSelector(
    (state: StateWithEmergencyCalls) => state.emergencyCalls,
  );

  useEffect(() => {
    dispatch(getNumNotifications());
  }, [dispatch, callQueue]);

  return numNotifications > 0 ? <Badge counter={numNotifications} /> : null;
};

export default EmergencyCallsBadge;
